import { ChangeEventHandler, KeyboardEvent, ReactElement, useCallback } from 'react';
import { TextField } from '@flos/react-ui';

import FormItem from 'components/FormItem/FormItem';

/* ============================================ Local Types ============================================ */
type THandleOnChange = ChangeEventHandler<HTMLInputElement>;

type THandleOnKeyDown = (event: KeyboardEvent<HTMLInputElement>) => void;

type TInput = (props: {
  id?: string;
  className?: string;
  label?: string;
  value?: string;
  iconShape?: string;
  isRequired?: boolean;
  onChange?: (value: string) => void;
  onPressEnter?: () => void;
}) => ReactElement;

/* ============================================ Main Component ============================================ */
const Input: TInput = ({
  id,
  className,
  label,
  value,
  iconShape,
  isRequired,
  onChange = () => {},
  onPressEnter = () => {}
}) => {
  const handleOnChange: THandleOnChange = useCallback(
    (e) => {
      const value = e.target.value;
      onChange(value);
    },
    [onChange]
  );

  const handleOnKeyDown: THandleOnKeyDown = useCallback(
    (event) => {
      if (event.key === 'Enter') {
        onPressEnter();
      }
    },
    [onPressEnter]
  );

  return (
    <FormItem className={className} label={label} isRequired={isRequired}>
      <TextField
        id={id ?? `input-${label}`}
        label="Angiv"
        value={value}
        iconShape={iconShape}
        onChange={handleOnChange}
        onKeyDown={handleOnKeyDown}
      />
    </FormItem>
  );
};

export default Input;
